import type { ISeriesPrototype } from "@/types/series.types";

export const withoutEvent = (payload: { seriesUuid: string; eventUuid: string }) => (ser: ISeriesPrototype) => {
	if (ser.events && ser.uuid === payload.seriesUuid) {
		ser.events = ser.events.filter((ev) => ev.uuid !== payload.eventUuid);
	}
	return ser;
};
